import { ButtonOld } from 'components/button';

import { OnboardingItem } from './onboarding-item';

import { useOnboarding } from './onboarding.state';
import { OnboardingStyles } from './onboarding.styles';
import { BUTTON_TEXT } from './onboarding.utils';

export const Onboarding = () => {
  const { ref, setting, onboardingItems, handleClick } = useOnboarding();

  return (
    <OnboardingStyles.Wrapper $isColumn $itemGap="2em">
      <OnboardingStyles.Slider ref={ref} {...setting}>
        {onboardingItems.map((item) => (
          <OnboardingItem key={item.title} {...item} />
        ))}
      </OnboardingStyles.Slider>

      <ButtonOld onClick={handleClick} title={BUTTON_TEXT} styleTheme="white" />
    </OnboardingStyles.Wrapper>
  );
};
